import { render, staticRenderFns } from "./Recepcion.vue?vue&type=template&id=059f7f74&scoped=true&"
import script from "./Recepcion.vue?vue&type=script&lang=js&"
export * from "./Recepcion.vue?vue&type=script&lang=js&"
import style0 from "./Recepcion.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Recepcion.vue?vue&type=style&index=1&id=059f7f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f7f74",
  null
  
)

export default component.exports